

export interface iMember {
	id: string,
	name: string
}
export enum StatusMember {
	alive,
	injured,
	dead
}
export interface iMemberEnhanced extends iMember {
	status: StatusMember
}
export interface iObjectives {
	name: string,
	completed: boolean
}
export interface iSpecialAction {
	name: string,
	active: boolean
}

export interface iSquad {
	id: string,
	members: iMemberEnhanced[],
	name: string,
	callSign: string,
	objectives: iObjectives[],
	specialActions: iSpecialAction[]
}